<div *ngIf="show" class="fade" [@state]="state" (@state.done)="animationDone($event)">
  <ng-content></ng-content>
</div>


